module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subscription-summary"
  }, [_c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('h2', {
    staticClass: "static-info--sub-heading"
  }, [_vm._v("Subscription Summary")])])], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.subsClub.item != undefined) ? [(_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('h3', [_vm._v("Unlimited movie tickets per month")]), _vm._v(" "), _c('h5', [_vm._v("Watch as many 2D or 3D movies as you want all month long.")]), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/morvies_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("UNLIMITED MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                Watch up to 5 movies a day, every day!\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-unlimited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("COME AS OFTEN AS YOU CAN")]), _vm._v(" "), _c('br'), _vm._v("\n                                                1 ticket per movie per card holder\n                                            ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                20% off a regular combo\n                                            ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('h3', [_vm._v("Limited movies per month")]), _vm._v(" "), _c('h5', [_vm._v("Get 4 2D or 3D movie tickets per month for you and your family.")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('div', {
    staticClass: "sk-club__join"
  }, [_c('h2', {
    staticClass: "h1"
  }, [_vm._v(_vm._s(_vm.subsClub.item.Price) + " "), _c('span', [_vm._v("per month")])])])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-responsive fan-img img-option",
    attrs: {
      "src": "/static/img/fan_club_card.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-tickets-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("4 MOVIE TICKETS PER MONTH")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    You watch more for less\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-limited-users-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("IDEAL FOR THE FAMILY")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    Use one or all four tickets at once\n                                                ")])])], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-combo-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("DISCOUNTS ON SNACKS")]), _vm._v(" "), _c('br'), _vm._v("\n                                                    20% off a regular combo\n                                                ")])])], 1)], 1)], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('sk-layout', {
    staticClass: "benefit",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs2": "",
      "sx2": "",
      "md2": ""
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/img/subs/subs-location-icon.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('sk-flex', {
    staticClass: "description",
    attrs: {
      "xs9": "",
      "sm9": "",
      "md9": ""
    }
  }, [_c('p', [_c('span', [_vm._v("NOW AVAILABLE AT ALL CINEMAS")])])])], 1)], 1)], 1)], 1)], 1)] : _vm._e()], _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sx12": "",
      "md8": ""
    }
  }), _vm._v(" "), (_vm.subsClub.item.Description.includes('Unlimited')) ? [_c('sk-flex', {
    attrs: {
      "sx6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Cancel Morvies Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelSubscription()
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Continue Morvies Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToNextStep()
      }
    }
  }, [_vm._v("NEXT")])], 1)] : [(_vm.subsClub.item.Description.includes('Limited')) ? [_c('sk-flex', {
    attrs: {
      "sx6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "tertiary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Cancel Fan Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelSubscription()
      }
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": "",
      "md2": ""
    }
  }, [_c('sk-button', {
    staticClass: "detail-movie-book-btn",
    attrs: {
      "primary": "",
      "block": (_vm.$breakpoints.xs),
      "contextValue": "Subscription Summary",
      "dataValue": "Continue Fan Club"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.continueToNextStep()
      }
    }
  }, [_vm._v("NEXT")])], 1)] : _vm._e()]], 2)] : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a56c2bd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/subs-club/subscription-summary/subscription-summary.vue
// module id = 804
// module chunks = 0